import React from 'react';

function HomeWhite(props) {
  return (
    <svg viewBox="0 0 28 28" {...props}>
      <g fill="#FFF" fillRule="evenodd">
        <path
          d="M19.333 20.087c0 .32-.263.58-.588.58H9.922a.584.584 0 01-.589-.58V7.913c0-.32.263-.58.589-.58h6.192c.176 0 .342.078.454.212l2.631 3.154a.573.573 0 01.134.368v9.02z"
          opacity={0.4}
        />
        <path
          d="M18.5 19.309c0 .216-.17.391-.382.391h-5.736a.387.387 0 01-.382-.391V11.09c0-.216.17-.391.382-.391h4.025c.115 0 .223.052.296.143l1.71 2.129c.056.07.087.158.087.248v6.089z"
          opacity={0.5}
        />
        <path d="M17.667 18.44c0 .143-.123.26-.275.26h-4.117a.268.268 0 01-.275-.26v-5.48c0-.143.123-.26.275-.26h2.89a.28.28 0 01.211.095l1.228 1.42c.04.046.063.105.063.165v4.059z" />
      </g>
    </svg>
  );
}

export default HomeWhite;
